<div class="listWrapper">
    
    <div class="listContainer">
        <div class="header-container">
        <div class="heading" id="iltSessionHeader">
            <h2>Register for the MCT Onboarding Experience</h2> 
        </div>
        <a class="nav-home-link" *ngIf="isHomeBtn" [routerLink]="'/home'">
            Navigate to HOME
        </a>
    </div>

        <div class="bannerWrapper">
            <topaz-banner bannerType="primary" useIcon disableScrolling disableCloseButton>
                <div banner-content>
                    <b>Please Select an Onboarding Experience Session</b>
                    <br />
                    <span class="topaz-banner-subcontent">
                        The MCT Onboarding Experience is currently available in a limited capacity. 
                        If you require additional time slots or would like to take the course in a different language, 
                        please email us at <a href="mailto:mctprog@microsoft.com">mctprog&#64;microsoft.com</a> for scheduling assistance.
                    </span>
                </div>
            </topaz-banner>
        </div>
       
        <!-- <div class="filter-container" [ngClass]="{ 'has-filters': hasSelectedFilters }">
            <div class="filter-controls-row">
                <topaz-single-filter (selectedFiltersChange)="applyCountryFilter($event)" filterName="Country"
                     [isSingleSelectWithIcon]="true" [clearButtonLabel]="'Clear all'" [filters]="countryData" 
                     [applyButtonLabel]="'Apply'" [(selectedFilters)]="selectedCountryFilter" 
                      ariaFilterTag="country-live-search" id="chipsCountryFilter">
                </topaz-single-filter>

                <topaz-single-filter (selectedFiltersChange)="applyTimeZoneFilter($event)" filterName="Time Zone"
                    [isSingleSelectWithIcon]="true" [clearButtonLabel]="'Clear all'" [filters]="timeZoneData" [applyButtonLabel]="'Apply'"
                    [(selectedFilters)]="selectedTimeZoneFilter" ariaFilterTag="time-zone-live-search" id="chipsTimeZoneFilter">
                </topaz-single-filter>
            </div>


            <div class="selected-filters-section">
                    <div class="selected-filters-row">

                        <mat-chip-listbox topazChipList aria-label="Country selection" role="listbox">
                            <div role="option">
                                @for (item of selectedCountryFilter; track item) {
                                <mat-chip-option [value]="item" (removed)="removeCountryFilterItem(item)">
                                    {{ item.name }}
                                    <button matChipRemove [attr.aria-label]="'Remove ' + item.name"
                                        [attr.id]="'remove-' + item.name">
                                        <fa-icon [icon]="icons.faXmark"></fa-icon>
                                    </button>
                                </mat-chip-option>
                                }
                            </div>
                        </mat-chip-listbox>

                         <mat-chip-listbox topazChipList aria-label="Time Zone selection" role="listbox">
                            <div role="option">
                                @for (item of selectedTimeZoneFilter; track item) {
                                <mat-chip-option [value]="item" (removed)="removeTimeZoneFilterItem(item)">
                                    {{ item.name }}
                                    <button matChipRemove [attr.aria-label]="'Remove ' + item.name"
                                        [attr.id]="'remove-' + item.name">
                                        <fa-icon [icon]="icons.faXmark"></fa-icon>
                                    </button>
                                </mat-chip-option>
                                }
                            </div>
                        </mat-chip-listbox>

                    </div>
            </div>
        </div> -->

        <div class="card-wrapper" (scroll)="onCardWrapperScroll($event)">
            <div class="card-container" *ngIf="isLoading && sessionCards.length === 0">
                <article class="session-card skeleton-card" *ngFor="let item of [1,2,3,4,5,6]">
                    <div class="session-card-header">
                        <div class="skeleton skeleton-radio"></div>
                        <div class="skeleton skeleton-title"></div>
                    </div>
                    <div class="session-card-divider"></div>
                    <div class="session-card-meta">
                        <div class="meta-block">
                            <div class="skeleton skeleton-small"></div>
                            <div class="skeleton skeleton-medium"></div>
                        </div>
                        <div class="meta-block">
                            <div class="skeleton skeleton-small"></div>
                            <div class="skeleton skeleton-medium"></div>
                        </div>
                    </div>
                    <div class="session-card-tile">
                        <div class="skeleton skeleton-large"></div>
                    </div>
                    <div class="skeleton skeleton-large"></div>
                </article>
            </div>

            <div class="empty-state" *ngIf="!isLoading && sessionCards.length === 0">
                <h4>No sessions available</h4>
                <p>No Instructor-Led Training sessions match the selected filters. Please adjust filters and try again.</p>
            </div>

            <mat-radio-group class="card-container" [value]="selectedSessionId" *ngIf="sessionCards.length > 0">
                <button type="button" class="session-card" *ngFor="let session of sessionCards"
                    [class.is-selected]="selectedSessionId === session.id" (click)="selectSession(session.id)" [attr.aria-labelledby]="'instructor-' + session.id + ' training-' + session.id">
                    <div class="session-card-header">
                        <mat-radio-button [value]="session.id" [checked]="selectedSessionId === session.id"
                            (change)="selectSession(session.id)" [attr.aria-label]="'Select session with ' + session.instructorName">
                        </mat-radio-button>
                        <h5>{{ session.instructorName }}</h5>
                    </div>

                    <div class="session-card-divider"></div>

                    <div class="session-card-meta">

                        <div class="session-card-details-grid">
                            MCT Onboarding Experience - {{ session.language }}
                            <!-- <div class="meta-block">
                                <span class="meta-label">Start Date</span>
                                <span class="meta-value meta-value-with-icon">
                                    <fa-icon [icon]="icons.faCalendar"></fa-icon>
                                    <span class="meta-regular-text">{{ session.startDate | date:'EEEE, MMMM d, y' }}</span>
                                </span>
                            </div>

                            <div class="meta-block">
                                <span class="meta-label">End Date</span>
                                <span class="meta-value meta-value-with-icon">
                                    <fa-icon [icon]="icons.faCalendar"></fa-icon>
                                    <span class="meta-regular-text">{{ session.endDate ? (session.endDate | date:'EEEE, MMMM d, y') : (session.startDate | date:'EEEE, MMMM d, y') }}</span>
                                </span>
                            </div> -->
                        </div>

                                            <div class="meta-block">
                        <span class="meta-label" [id]="'datetime-heading-' + session.id">Date & Time</span>

                        <!-- Start Date -->
                        <div class="meta-block">
                            <span class="meta-label" [id]="'start-label-' + session.id">Start Date</span>
                            <span class="meta-value meta-value-with-icon">
                                <fa-icon [icon]="icons.faCalendar" aria-hidden="true"></fa-icon>
                                <span class="meta-regular-text" [attr.aria-labelledby]="'start-label-' + session.id">
                                    {{ session.startDate | date:'EEEE, MMMM d, y' }}
                                </span>
                            </span>
                        </div>

                        <!-- End Date -->
                        <div class="meta-block">
                            <span class="meta-label" [id]="'end-label-' + session.id">End Date</span>
                            <span class="meta-value meta-value-with-icon">
                                <fa-icon [icon]="icons.faCalendar" aria-hidden="true"></fa-icon>
                                <span class="meta-regular-text" [attr.aria-labelledby]="'end-label-' + session.id">
                                    {{ session.endDate ? (session.endDate | date:'EEEE, MMMM d, y') : (session.startDate | date:'EEEE, MMMM d, y') }}
                                </span>
                            </span>
                        </div>

                        <!-- Time -->
                        <div class="meta-block">
                            <span class="meta-label" [id]="'time-label-' + session.id">Time</span>
                            <span class="meta-value meta-value-with-icon">
                                <fa-icon [icon]="icons.faClock" aria-hidden="true"></fa-icon>
                                <span class="meta-regular-text" [attr.aria-labelledby]="'time-label-' + session.id">
                                    {{ session.trainingTiming }} {{ session.timezone }}
                                </span>
                            </span>
                        </div>
                    </div>
                        <div class="session-card-details-grid">
                            <!-- <div class="meta-block">
                                <span class="meta-label">Language</span>
                                <span class="meta-value meta-value-with-icon">
                                    <fa-icon [icon]="icons.faLanguage"></fa-icon>
                                    <span class="meta-regular-text">{{ session.language || '-' }}</span>
                                </span>
                            </div> -->

                            <div class="meta-block">
                                <span class="meta-label">Location</span>
                                <span class="meta-value meta-value-with-icon">
                                    <fa-icon [icon]="icons.faMapMarkerAlt"></fa-icon>
                                    <span class="meta-regular-text">{{ session.location || '-' }}</span>
                                </span>
                            </div>
                        </div>

                    </div>

                     <div class="session-card-tile">
                        <strong>{{ session.trainingName }}</strong>
                    </div>
                    
                </button>
            </mat-radio-group>

            <div class="scroll-load-indicator" *ngIf="isLoading && sessionCards.length > 0">
                <mat-spinner diameter="32"></mat-spinner>
            </div>
        </div>
    </div>
</div>